import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowSmallLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m14 8-4 4 4 4"
    />
  </svg>
);
export default SvgArrowSmallLeft;
